import { Alert, Typography } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type TransferFilesStatusContentProps = {
	isError: boolean;
	isLoading: boolean;
	isEmpty: boolean;
	children: React.ReactNode;
};

export function TransferFilesStatusContent({
	isError,
	isLoading,
	isEmpty,
	children,
}: TransferFilesStatusContentProps): React.ReactNode {
	const { t } = useTranslation(['component', 'common']);

	if (isError) {
		return (
			<Alert severity="warning">
				{t('component:failed-to-load-files')}
			</Alert>
		);
	}

	if (isLoading) {
		return (
			<Typography variant="body2" color="text.secondary">
				{t('common:loading-placeholder')}
			</Typography>
		);
	}

	if (isEmpty) {
		return (
			<Typography variant="body2" color="text.secondary">
				{t('component:no-files-uploaded-yet')}
			</Typography>
		);
	}

	return <>{children}</>;
}
